

export const generateVignettes = async (fetchCategories, questionTopic, selectedCategories, axiosPrivate, ageData, genderData) => {
  const filteredCategories = fetchCategories.filter(cat =>
    selectedCategories.includes(cat.mcq_category)
  );
  const response = await axiosPrivate.post(
    "/generate_vignettes/", {
    questionTopic,
    fetchCategories: filteredCategories,
    ageData,
    genderData,
  },
    {
      headers: {
        "Content-Type": "application/json",
      },
      withCredentials: true,
    }
  );

  const data = response.data;

  // The API returns data directly (not nested in choices.message.content)
  const vignetteList = data.vignetteList || [];
  const fields = data.fields || [];
  const mcqs = data.mcqs || [];

  return { vignetteList, fields, mcqs };
};